module.exports = __webpack_public_path__ + "static/media/sun-icon.3718a2d7.svg";